import { Suspense, lazy, type ReactNode } from 'react';
import { Navigate, createBrowserRouter } from 'react-router-dom';
import { App } from './App';
import { RequireAuth } from './components/RequireAuth';

const LoginPage = lazy(() => import('./pages/Login').then((module) => ({ default: module.LoginPage })));
const ResetPasswordPage = lazy(() => import('./pages/ResetPassword').then((module) => ({ default: module.ResetPasswordPage })));
const ChannelsPage = lazy(() => import('./pages/Channels').then((module) => ({ default: module.ChannelsPage })));
const ChannelDetailPage = lazy(() => import('./pages/ChannelDetail').then((module) => ({ default: module.ChannelDetailPage })));
const StreamWatchPage = lazy(() => import('./pages/StreamWatch').then((module) => ({ default: module.StreamWatchPage })));
const SearchPage = lazy(() => import('./pages/Search').then((module) => ({ default: module.SearchPage })));
const ClipsPage = lazy(() => import('./pages/Clips').then((module) => ({ default: module.ClipsPage })));
const LeaderboardPage = lazy(() => import('./pages/Leaderboard').then((module) => ({ default: module.LeaderboardPage })));
const SettingsPage = lazy(() => import('./pages/Settings').then((module) => ({ default: module.SettingsPage })));
const AccountSecurityPage = lazy(() => import('./pages/Settings').then((module) => ({ default: module.AccountSecurityPage })));
const OperationsPage = lazy(() => import('./pages/Operations').then((module) => ({ default: module.OperationsPage })));
const WorkspacePage = lazy(() => import('./pages/Workspace').then((module) => ({ default: module.WorkspacePage })));
const InvitePage = lazy(() => import('./pages/Invite').then((module) => ({ default: module.InvitePage })));

function page(node: ReactNode) {
  return (
    <Suspense fallback={<div className="p-4 text-sm text-ink-400 sm:p-6">Loading…</div>}>
      {node}
    </Suspense>
  );
}

export const router = createBrowserRouter([
  { path: '/login', element: page(<LoginPage />) },
  { path: '/reset-password', element: page(<ResetPasswordPage />) },
  { path: '/invite/:token', element: page(<InvitePage />) },
  {
    path: '/',
    element: (
      <RequireAuth>
        <App />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="/channels" replace /> },
      { path: 'channels', element: page(<ChannelsPage />) },
      { path: 'channels/:channelId', element: page(<ChannelDetailPage />) },
      { path: 'streams/:streamId/watch', element: page(<StreamWatchPage />) },
      { path: 'search', element: page(<SearchPage />) },
      { path: 'clips', element: page(<ClipsPage />) },
      { path: 'leaderboard', element: page(<LeaderboardPage />) },
      { path: 'settings', element: page(<SettingsPage />) },
      { path: 'security', element: page(<AccountSecurityPage />) },
      { path: 'operations', element: page(<OperationsPage />) },
      { path: 'workspace', element: page(<WorkspacePage />) },
    ],
  },
]);
